<template>
    <div>
        <div class="page-wrapper login-page">
            <div class="page-bg" :style="{'background-image': `url('${$store.getters.getBgLogin}')`}"></div> 
            <div class="naos-logo" :style="{'background-image': `url('${$store.getters.getLogoNao}')`}"></div>
            <div class="bioderma-logo" :style="{'background-image': `url('${$store.getters.getLogoBioderma}')`}"></div>
            <div class="page-content">
                <div class="img-login"></div>
                <div class="wrapper-login">
                    <div class="header-login">
                        <div class="text">
                            <p>{{lbl.login.text_title}}</p>
                        </div>
                    </div>
                    <InputContactNumber
                        inputId="contact_number"
                        delimeter="-"
                        :inputLbl="lbl.login.contactnumber"
                        :inputMinLength="10"
                        :inputMaxLength="10"
                        :errorInfo="errorInfo[0]"
                        v-model="contactNumber">
                    </InputContactNumber>
                    <div class="text-error">{{textError}}</div>
                    <Button
                        btnId="login_btn"
                        :btnMsg="lbl.login.confirm_btn"
                        :isBtnDisable="!isFormValid"
                        @clickButton="clickLogin()">
                    </Button>
                    <div class="bottom-login">
                        <div class="logo-bzbs">
                            <img src="@/assets/bzbslogo/bzbs-new-logo.svg">
                        </div>
                        <div @click="onClickSkip()" class="text-skip">
                            {{lbl.login.text_skip}}
                            <img src="@/assets/icon/login_icon_back@2x.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalMaster :controller="modalController" />
    </div>
</template>
<script>
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";

//component
import InputContactNumber from "@/components/Input/ContactNumber.vue";
import Button from "@/components/Button/Button.vue";
//service
import RegisterApi from "@/core/Bioderma/service/RegisterApi.js";
//herlper
import { TrackingService } from "@/helper/TrackingHelper.js";
import CacheHelper from "@/helper/CacheHelper.js";
export default {
    name: "Login",
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin],
    components: {
        InputContactNumber,
        Button
    },
    data: function() {
        return {
            errorInfo: [],
            isFormValid: false,
            contactNumber: '',
            textError: '',
            tracking: new TrackingService(this)
        };
    },
    watch: {
        contactNumber: function () {
            this.watchValidate();
        },
    },
    created: function() {

        this.initialValidateData();
        this.tracking.screenName('Register_Page');
    },
    methods: {
        //event
        clickLogin: function() {
            var result = this.validate();
            if (result.isValid) {
                //get otp
                this.otpModal.startOtp(this.contactNumber, 'register');
                this.otpModal.onSubmitOtp(data => {
                    console.log('success',data);
                    this.textError = '';
                    this.checkUser(data);
                });
                //error
                this.otpModal.onError((err) =>{
                    console.log('err', err);
                    if(err.id == 2078){
                        var cache = new CacheHelper('local');
                        this.textError = 'ขออภัยค่ะ เบอร์โทรศัพท์ของท่านมีอยู่แล้วในระบบ';
                        cache.setCache('contact_change_line', this.contactNumber);
                        window.location.href = "/verify/birthday";
                    }
                });
                //success
                this.otpModal.onSuccess(() =>{
                    this.textError = '';
                });

            } else {
                this.alertModal.setMsg(result.msg).show();
            }
            this.tracking.event('fill_mobileno_register','click_confirm_mobileno_register');
        },
        checkUser: function(data){
            var otpModel = {
                otp: data.otp,
                refcode: data.refcode,
            }
            RegisterApi.apiCheckUser(data.contactNumber, otpModel).subscribe((res) =>{
                console.log("check",res);
                if(!res.success){
                    this.alertModal
                        .setMsg(res.message)
                        .show();
                }else{
                    console.log("success");
                }

            },(err) => {
                this.loadingModal.hide();
                this.errorApi(err);
            });
        },
        //initial
        initialValidateData: function() {
            for (var i = 0; i < 1; i++) {
                this.errorInfo.push({
                    isValid: true,
                    msg: ""
                });
            }
        },
        //method
        validate: function() {
            var result = {
                isValid: true,
                msg: null
            };

            for (var err of this.errorInfo) {
                if (!err.isValid) {
                    result.isValid = false;
                    result.msg = err.msg;
                    return result;
                }
            }

            return result;
        },
        watchValidate: function () {
            if (this.errorInfo[0].isValid) {
                this.isFormValid = true;
            } else {
                this.isFormValid = false;
            }
        },
        onClickSkip: function () {
            window.location.replace('/home');
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "../style/Login.scss";
</style>
<style lang="scss">
@import "@/style/base/base.scss";
.login-page{
    .btn-wrapper{
        @include mini-mobile(){
            margin-top: 23px;
        }
    }
}
</style>
